import React, { useEffect, useState, useRef } from "react";
import InputText from "../ReusableComponents/InputText";
import DropDown from "../ReusableComponents/DropDown";
import Buttons from "../components/Buttons";
import { mainTable } from "../css/Common";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import { BindAPI, IUDAPI, BindPostAPI } from "../services/APIConnection";
import FileUpload from "../ReusableComponents/FileUpload";
import toast from "react-hot-toast";

const Cancelpopup = ({
  data,
  data1,
  data2,
  data3,
  isOpen,
  isSubmit,
  viewPopUp,
}) => {
  // var Name = data;
  const [bookingGuestDetails, setBookingGuestDetails] = useState("");
  useEffect(() => {
    console.log("Received in popup: ", data, data1, data2, data3);
  }, [data, data1]);
  const [lostreasondropdown, setlostreasondropdown] = useState([]);
  const [selectedRooms, setSelectedRooms] = useState({});
  const [formData, setFormData] = useState({
    enquiryDate: null,
    enquiryId: null,
    bookingId: null,
    bookingDate: null,
    bookingFrom: null,
    bookingTo: null,
    noOfDays: null,
    firstName: null,
    lastName: null,
    mobileNumber: null,
    country: 0,
    state: 0,
    city: null,
    streetDoorNo: null,
    area: null,
    pincode: null,
    sourceType: 0,
    source: null,
    contactNumber: null,
    idType: 0,
    idValue: null,
    bookingTotalAmount: null,
    bookingReceivedAmount: null,
    lostReason: 0,
    refundAmount: 0,
    revenue: 0,
    bookingBalanceAmount: null,
    bookingPaymentType: null,
    bookingPaymentReferenceNumber: null,
    showImage: null,
  });
  var clientId = sessionStorage.getItem("MstClientId");
  useEffect(() => {
    if (data) {
      const today = new Date().toISOString().split("T")[0]; // "YYYY-MM-DD" format

      setFormData({
        enquiryDate: data?.EnquiryDate || null,
        enquiryId: data?.EnquiryNo || null,
        bookingId: data?.BookingNo || null,
        bookingDate: data?.BookingDate || null,
        bookingFrom: data?.BookingFrom || null,
        bookingTo: data?.BookingTo || null,
        noOfDays: data?.BookingPersonNoOfDays || null,
        firstName: data?.BookingPersonFirstName || null,
        lastName: data?.BookingPersonLastName || null,
        mobileNumber: data?.BookingPersonMobileNumber || null,
        country: data?.BookingPersonMstCountryId || 0,
        state: data?.BookingPersonMstStateId || 0,
        city: data?.BookingPersonMstCityId || null,
        streetDoorNo: data?.BookingPersonStreetDoorNo || null,
        area: data?.BookingPersonArea || null,
        pincode: data?.BookingPersonPincode || null,
        sourceType: data?.MstSourceId || 0,
        source: data?.Source || null,
        contactNumber: data?.BookingContactNumber || null,
        idType: data?.MstIdProofId || 0,
        idValue: data?.IdNumber || null,
        email: data?.Email || null,
        bookingTotalAmount: parseInt(data?.TotalAmount, 10) || null,
        bookingReceivedAmount: parseInt(data?.BookingReceivedAmount, 10) || null,
        refundAmount: data?.RefundAmount ? parseFloat(data?.RefundAmount) : 0,
        revenue: data?.BookingReceivedAmount
          ? parseFloat(data?.BookingReceivedAmount)
          : 0,
        bookingBalanceAmount: parseInt(data?.BookingBalanceAmount, 10) || null,
        bookingPaymentType: viewPopUp ? data?.BookingPaymentType : null,
        bookingPaymentReferenceNumber: viewPopUp
          ? data?.BookingPaymentReferenceNumber
          : null,
          lostReason: data?.MstCancellationReasonId
          ? Number(data?.MstCancellationReasonId)
          : 0,
        showImage: viewPopUp ? data?.BookingPaymentReference : null,
      });
    }
  }, [data]); // runs every time `data` changes
  useEffect(() => {
    BindGetEnquiryValues();
  }, []);

  const BindGetEnquiryValues = async () => {
    const data = {
      mstClientId: clientId,
    };
    const response = await BindPostAPI(data, "Enquiry/BindGetEnquiryValues");
    if (response && response.data) {
      const LostReasonId = response?.data?.Table12?.map((item) => ({
        value: item.MstCancellationReasonId,
        label: item.Reason,
      }));

      setlostreasondropdown(LostReasonId);
    } else {
      //setBindEnquiryData([]);
    }
  };
  const [formDataError, setFormDataError] = useState({
    enquiryDateError: "",
    enquiryIdError: "",
    bookingIdError: "",
    bookingDateError: "",
    bookingFromError: "",
    bookingToError: "",
    noOfDaysError: "",
    firstNameError: "",
    lastNameError: "",
    mobileNumberError: "",
    countryError: "",
    stateError: "",
    cityError: "",
    streetDoorNoError: "",
    areaError: "",
    pincodeError: "",
    sourceTypeError: "",
    lostReasonError: "",
    sourceError: "",
    contactNumberError: "",
    idTypeError: "",
    idValueError: "",
    emailError:"",
    showImageError: "",
    bookingPaymentTypeError: "",
  });

  const [countrydropdown, setcountrydropdown] = useState(data1[0] || []);

  const [statedropdown, setstatedropdown] = useState(data1[1] || []);

  const [referralSourceDropdown, setReferralSourceDropdown] = useState([]);

  const [iddropdown, setiddropdown] = useState([]);

  const [paymenttypedropdown, setPaymentTypeDropdown] = useState([]);

  const fieldLabels = {
    // country: { label: "Country", type: "select-one" },
    // state: { label: "State", type: "select-one" },
    // districts: { label: "Districts", type: "select-one" },
    // city: { label: "City", type: "select-one" },
    // referralsource: { label: "Referral Source", type: "select-one" },
    // adults: { label: "Adults", type: "select-one" },
    // children: { label: "Children", type: "select-one" },
    // idproof: { label: "Id-Proof", type: "select-one" },
    refundAmount: { label: "Refund Amount", type: "text" },
    revenue: { label: "Revenue", type: "text" },

    bookingPaymentType: {
      label: "Payment Reference Number",
      type: "select-one",
    },
    bookingPaymentReferenceNumber: {
      label: "Payment Ref Number",
      type: "text",
    },
  };
  // const villaselectchange = async (updatedOptions) => {
  //   const selectedItems = selVillaType.filter((item) =>
  //     updatedOptions.includes(item.value)
  //   );
  // };

  // const handletableDataChange = (selectedOption, rowIndex, columnName) => {
  //
  //   const value = selectedOption ? parseInt(selectedOption.value) : 0;
  //   setTableData((prevTableData) => {
  //     const updatedData = [...prevTableData];
  //     updatedData[rowIndex] = { ...updatedData[rowIndex], [columnName]: value };
  //     convertArrayToJSONString(updatedData);
  //     return updatedData;
  //   });
  //   // if (tableData.length > 0) {
  //   //   setSubmitBtnDisabled(false);
  //   //   setStudentDetailsError("");
  //   // }
  // };

  const handletableDataChange = (selectedOption, rowIndex, columnName) => {
    const value = selectedOption ? parseInt(selectedOption.value) : 0;

    setTableData((prevTableData) => {
      const updatedData = [...prevTableData];

      // Update the specific column value
      updatedData[rowIndex] = {
        ...updatedData[rowIndex],
        [columnName]: value,
      };

      // Get both values (treat missing/invalid as 0)
      const specialtariff =
        parseFloat(updatedData[rowIndex].specialtariff) || 0;
      const numberofrooms = parseInt(updatedData[rowIndex].Numberofrooms) || 0;

      // If either relevant field changed, update amount
      if (["specialtariff", "Numberofrooms"].includes(columnName)) {
        updatedData[rowIndex].amount = specialtariff * numberofrooms;
      }

      convertArrayToJSONString(updatedData);
      return updatedData;
    });

    // Optional: Enable submit if data exists
    // if (tableData.length > 0) {
    //   setSubmitBtnDisabled(false);
    //   setStudentDetailsError("");
    // }
  };

  const convertArrayToJSONString = (array) => {
    try {
      const jsonString = JSON.stringify(array);
      setBookingGuestDetails(jsonString);
      return jsonString;
    } catch (error) {
      console.error("Error converting array to JSON string:", error);
      return null;
    }
  };

  const [tableData, setTableData] = useState([]);
  useEffect(() => {
    if (data2?.length > 0) {
      setTableData(data2);
    } else {
      setTableData([]);
    }
  }, [data2]);

  const handleBlur = (e) => {
    const { name, value } = e.target;
    const field = fieldLabels[name];
    if (!field) return;

    const label = field.label;
    const type = field.type;

    const message =
      value.trim() === ""
        ? type === "select-one"
          ? `Select ${label}`
          : `Enter ${label}`
        : "";

    setFormDataError((prevErrors) => ({
      ...prevErrors,
      [name]: message,
    }));
  };

  const validateForm = (action) => {
    let fieldsToValidate = [];
    const newErrors = {};
    let formValid = true;

    if (action === "save") {
      fieldsToValidate = ["amountpaid", "payrefnumber", "paymenttype"];
    }

    fieldsToValidate.forEach((key) => {
      const value = formData[key] || "";
      const field = fieldLabels[key];

      if (!field) return; // skip unknown fields

      const { label, type } = field;

      if (value.trim() === "") {
        const message =
          type === "select-one" ? `Select ${label}` : `Enter ${label}`;
        newErrors[key] = message;
        formValid = false;
      }
    });

    setFormDataError(newErrors); // <- make sure this updates your UI
    return formValid; // <- return the result for the calling function

    if (formValid && action === "save") {
      //setVisibleAdd(false)
      //setVisibleTable(true);
    } else {
      console.log(` Validation failed for "${action}"`);
    }
  };

  const handleInputChangeTable = (e, index) => {
    const { name, value } = e.target;
    const updated = [...tableData];
    updated[index][name] = value;
    setTableData(updated);
  };

  const handleDeleteRow = (index) => {
    const newTableData = [...tableData];
    newTableData.splice(index, 1);
    setTableData(newTableData);
  };

  const handleAddRow = () => {
    if (tableData.length < 4) {
      setTableData([
        ...tableData,
        { itemType: "", category: "", itemName: "", batchNo: "", quantity: "" },
      ]);
    }
  };
  const checkboxRef = useRef();

  const handleClick = () => {
    alert(`Checked: ${checkboxRef.current.checked}`);
  };

  const numbers = [1, 2];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };
  const onSave = () => {
    validateForm("save");
  };
  if (!data) return null;

  const handleDropdownChange = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const controlBlur = () => { };
  const handleSelectAll = (roomIndex, totalRooms) => {
    setSelectedRooms((prev) => ({
      ...prev,
      [roomIndex]: Array.from({ length: totalRooms }, (_, i) => i + 1),
    }));
  };

  const handleUnselectAll = (roomIndex) => {
    setSelectedRooms((prev) => ({
      ...prev,
      [roomIndex]: [],
    }));
  };

  // const handleToggleRoom = (roomIndex, number) => {
  //   setSelectedRooms((prev) => {
  //     const current = prev[roomIndex] || [];
  //     const isSelected = current.includes(number);

  //     return {
  //       ...prev,
  //       [roomIndex]: isSelected
  //         ? current.filter((n) => n !== number)
  //         : [...current, number],
  //     };
  //   });
  // };
  const handleToggleRoom = (roomIndex, roomId) => {
    setSelectedRooms((prev) => {
      const current = prev[roomIndex] || [];
      const isSelected = current.includes(roomId);

      const updatedSelection = isSelected
        ? current.filter((id) => id !== roomId)
        : [...current, roomId];

      // ✅ Update tableData with selectedRooms string for the specific row
      setTableData((prevTable) => {
        const newTable = [...prevTable];
        if (newTable[roomIndex]) {
          newTable[roomIndex] = {
            ...newTable[roomIndex],
            selectedRooms: updatedSelection.join(","), // Convert to "1,2,3"
          };
        }
        return newTable;
      });

      // ✅ Return updated selectedRooms state
      return {
        ...prev,
        [roomIndex]: updatedSelection,
      };
    });
  };
  const cancel = () => {
    isOpen(false);
    const today = new Date().toISOString().split("T")[0]; // "YYYY-MM-DD" format
    setFormData({
      enquiryDate: null,
      enquiryId: null,
      bookingId: null,
      bookingDate: today,
      bookingFrom: null,
      bookingTo: null,
      noOfDays: null,
      firstName: null,
      lastName: null,
      mobileNumber: null,
      country: null,
      state: null,
      city: null,
      streetDoorNo: null,
      area: null,
      pincode: null,
      sourceType: null,
      source: null,
      contactNumber: null,
      idType: null,
      idValue: null,
      email:null,
      bookingTotalAmount: null,
      bookingReceivedAmount: null,
      bookingBalanceAmount: null,
      bookingPaymentType: null,
      bookingPaymentReferenceNumber: null,
      showImage: "",
    });
    setFormDataError({
      enquiryDateError: "",
      enquiryIdError: "",
      bookingIdError: "",
      bookingDateError: "",
      bookingFromError: "",
      bookingToError: "",
      noOfDaysError: "",
      firstNameError: "",
      lastNameError: "",
      mobileNumberError: "",
      countryError: "",
      stateError: "",
      cityError: "",
      streetDoorNoError: "",
      areaError: "",
      pincodeError: "",
      sourceTypeError: "",
      sourceError: "",
      contactNumberError: "",
      idTypeError: "",
      idValueError: "",
      emailError:"",
      showImageError: "",
      bookingPaymentTypeError: "",
    });
    isSubmit(true);
    // setpopUpBookOpen(false);
  };
  const createdBy = sessionStorage.getItem("createdBy");
  const handleSubmit = async (items, flag) => {

    const data = {
      enquiryDate: formData?.enquiryDate,
      enquiryId: formData?.enquiryId,
      bookingId: formData?.bookingId,
      bookingDate: formData?.bookingDate,
      bookingFrom: formData?.bookingFrom,
      bookingTo: formData?.bookingTo,
      noOfDays: formData?.noOfDays,
      firstName: formData?.firstName,
      lastName: formData?.lastName,
      mobileNumber: formData?.mobileNumber,
      country: formData?.mstCountryId,
      state: formData?.mstStateId,
      city: formData?.mstCityId,
      streetDoorNo: formData?.streetDoorNo,
      area: formData?.area,
      pincode: formData?.pincode,
      sourceType: formData?.sourceType,
      source: formData?.source,
      contactNumber: formData?.contactNumber,
      idType: formData?.idType,
      idValue: formData?.idValue,
      email:formData?.email,
      mstCancellationReasonId: Number(formData.lostReason || 0),
      bookingTotalAmount: formData?.bookingTotalAmount,
      bookingReceivedAmount: formData?.bookingReceivedAmount,
      bookingBalanceAmount: formData?.bookingBalanceAmount,
      cancelRefundAmount: formData?.refundAmount,
      cancelRevenue: formData?.revenue,
      cancelPaymentType: formData?.bookingPaymentType,
      cancelPaymentReferenceNumber: formData?.bookingPaymentReferenceNumber,
      cancelData: JSON.stringify(tableData),
      showImage: formData?.showImage,
      flag: flag,
      createdBy: parseInt(createdBy, 10),
    };
    
    const response = await IUDAPI(data, "Enquiry/IUDCancelBooking");
    if (flag == 1) {
      //if flag ==1 , add
      if (response.data.Table[0].Result === "S") {
        toast.success("Room Cancellation successful", {
          duration: 3000,
          position: "top-center",
        });
        setTimeout(cancel, 3000);
      } else {
        toast.error("Failed to cancel room", {
          duration: 3000,
          position: "top-center",
        });
        setTimeout(cancel, 3000);
      }
    }
  };
  // const handleSubmit = (items, flag) => {
  //   console.log("tableData:", tableData, JSON.stringify(tableData));
  //      ;
  //   const data = {
  //     enquiryDate: formData?.enquiryDate,
  //     enquiryId: formData?.enquiryId,
  //     bookingId: formData?.bookingId,
  //     bookingDate: formData?.bookingDate,
  //     bookingFrom: formData?.bookingFrom,
  //     bookingTo: formData?.bookingTo,
  //     noOfDays: formData?.noOfDays,
  //     firstName: formData?.firstName,
  //     lastName: formData?.lastName,
  //     mobileNumber: formData?.mobileNumber,
  //     country: formData?.country,
  //     state: formData?.state,
  //     city: formData?.city,
  //     streetDoorNo: formData?.streetDoorNo,
  //     area: formData?.area,
  //     pincode: formData?.pincode,
  //     sourceType: formData?.sourceType,
  //     source: formData?.source,
  //     contactNumber: formData?.contactNumber,
  //     idType: formData?.idType,
  //     idValue: formData?.idValue,
  //     bookingTotalAmount: formData?.bookingTotalAmount,
  //     bookingReceivedAmount: formData?.bookingReceivedAmount,
  //     bookingBalanceAmount: formData?.bookingBalanceAmount,
  //     bookingPaymentType: formData?.bookingPaymentType,
  //     bookingPaymentReferenceNumber: formData?.bookingPaymentReferenceNumber,
  //     bookingData: JSON.stringify(tableData),
  //     showImage: formData?.showImage,
  //     flag: flag,
  //     createdBy: parseInt(createdBy, 10),
  //   };
  //   const response = IUDAPI(data, "Enquiry/IUDConfirmBooking");
  // };
  const handleShowImage = (showImage) => {
    // showImage &&
    setFormData({
      ...formData,
      showImage: showImage && typeof showImage === "string" && showImage.trim() !== "" ? showImage : "",
    });
    setFormDataError({
      ...formDataError,
      showImageError: "",
    });
  };
  return (
    <>
      <div className="mx-auto p-8 maxw-7xl">
        <div className={mainTable.grid3}>
          <InputText
            inputType="date"
            title="Enquiry Date"
            name="enquiryDate"
            controlFunc={handleInputChange}
            controlFuncBlur={handleBlur}
            // content={formData?.enquiryDate}
            content={
              formData?.enquiryDate ? formData.enquiryDate.substring(0, 10) : ""
            }
            placeholder="Enter Enquiry Date"
            disabled={true}
            // tabIndex="9"
            isRequired={true}
            classStar="text-red-500"
          // errorMessage={formDataError.EnquiryDate}
          />
          <InputText
            inputType="text"
            title="Enquiry ID"
            name="enquiryId"
            content={formData?.enquiryId || null}
            disabled={true}
            placeholder="ENQ-2025-000001"
            // tabIndex="11"
            isRequired={true}
          />

          <InputText
            inputType="text"
            title="Booking ID"
            name="bookingId"
            content={formData?.bookingId || null}
            placeholder="BKG-2025-000001"
            disabled={true}
            // tabIndex="8"
            isRequired={true}
          />

          <InputText
            inputType="date"
            title="Booking Date"
            name="bookingDate"
            controlFunc={handleInputChange}
            controlFuncBlur={handleBlur}
            // content={formData?.bookingDate || null}
            content={
              formData?.bookingDate ? formData.bookingDate.substring(0, 10) : ""
            }
            // content={formData?.bookingdate}
            placeholder="Enter Booking Date"
            disabled={true}
            // tabIndex="9"
            isRequired={true}
            classStar="text-red-500"
            errorMessage={formDataError.bookingDateError}
            max={new Date().toISOString().split("T")[0]}
          />

          <InputText
            inputType="date"
            title="Booking From"
            name="bookingFrom"
            controlFunc={handleInputChange}
            controlFuncBlur={handleBlur}
            // content={formData?.bookingFrom || ""}
            content={
              formData?.bookingFrom ? formData.bookingFrom.substring(0, 10) : ""
            }
            disabled={true}
            // tabIndex="9"
            isRequired={true}
            classStar="text-red-500"
            errorMessage={formDataError.bookingFromError}
          />
          <InputText
            inputType="date"
            title="Booking To"
            name="bookingTo"
            controlFunc={handleInputChange}
            controlFuncBlur={handleBlur}
            // content={formData?.bookingTo || ""}
            content={
              formData?.bookingTo ? formData.bookingTo.substring(0, 10) : ""
            }
            disabled={true}
            // tabIndex="9"
            isRequired={true}
            classStar="text-red-500"
            errorMessage={formDataError.bookingToError}
          />
          <InputText
            inputType="text"
            title="Number of Days"
            name="noOfDays"
            controlFunc={handleInputChange}
            controlFuncBlur={handleBlur}
            content={formData?.noOfDays || ""}
            placeholder="Enter Number of Days"
            disabled={true}
            // tabIndex="9"
            classStar="text-red-500"
            isRequired={true}
            errorMessage={formDataError.noOfDaysError}
          />

          <InputText
            inputType="text"
            title="First Name"
            name="firstName"
            content={formData?.firstName || ""}
            controlFunc={handleInputChange}
            controlFuncBlur={(e) => {
              const value = formData?.firstName?.trim() || "";

              const error = !value
                ? "Enter First Name"
                : value.length < 2
                  ? "Minimum 2 characters required"
                  : value.length > 100
                    ? "Maximum 100 characters allowed"
                    : /^[A-Za-z.'\- ]+$/.test(value)
                      ? ""
                      : "Only alphabets, dot, apostrophe, hyphen, and space allowed";

              setFormDataError((prev) => ({
                ...prev,
                firstNameError: error,
              }));
            }}
            disabled={true}
            maxLength={100}
            // tabIndex="1"
            isRequired={true}
            classStar="text-red-500"
            errorMessage={formDataError.firstNameError}
          />

          <InputText
            inputType="text"
            title="Last Name"
            name="lastName"
            disabled={true}
            content={formData?.lastName || ""}
            controlFunc={handleInputChange}
            // tabIndex="2"
            isRequired={true}
            // classStar="text-red-500"
            controlFuncBlur={(e) => {
              const value = formData?.lastName?.trim() || "";

              const error = !value
                ? "Enter Last Name"
                : value.length < 2
                  ? "Minimum 2 characters required"
                  : value.length > 100
                    ? "Maximum 100 characters allowed"
                    : /^[A-Za-z.'\- ]+$/.test(value)
                      ? ""
                      : "Only alphabets, dot, apostrophe, hyphen, and space allowed";

              setFormDataError((prev) => ({
                ...prev,
                lastNameError: error,
              }));
            }}
            errorMessage={formDataError.lastNameError}
          />

          <InputText
            inputType="text"
            title="Mobile Number"
            name="mobileNumber"
            content={formData?.mobileNumber || ""}
            controlFunc={handleInputChange}
            controlFuncBlur={(e) => {
              setFormDataError((formDataError) => ({
                ...formDataError,
                mobileNumberError:
                  formData.mobileNumber && formData.mobileNumber.length > 0
                    ? /^\+?[0-9]{7,15}$/.test(formData.mobileNumber)
                      ? ""
                      : "Only digits allowed, with optional + at start (7 to 15 digits)"
                    : "Enter Contact Number",
              }));
            }}
            placeholder="Enter your mobile number"
            disabled={true}
            // tabIndex="3"
            isRequired={true}
            classStar="text-red-500"
            errorMessage={formDataError.mobileNumberError}
          />
          <AutoDropDown
            title="Country"
            placeholder="Select"
            options={data1[0]}
            name="country"
            Class="custom-class"
            // tabIndex="1"
            disabled={true}
            selectedOption={data1[0]?.find((x) => x.value == formData?.country)}
            classStar="text-red-500"
            controlFunc={(value) =>
              setFormData({
                ...formData,
                country: value.value,
              })
            }
            controlFuncBlur={() => {
              setFormDataError(() => ({
                ...formDataError,
                countryError: formData.country ? "" : "Select Country",
              }));
            }}
            errorMessage={formDataError.countryError}
          />

          <AutoDropDown
            title="State"
            placeholder="Select"
            options={data1[1]}
            name="state"
            Class="custom-class"
            // tabIndex="1"
            disabled={true}
            selectedOption={data1[1]?.find((x) => x.value == formData?.state)}
            classStar="text-red-500"
            controlFunc={(value) =>
              setFormData({
                ...formData,
                state: value.value,
              })
            }
            controlFuncBlur={() => {
              setFormDataError(() => ({
                ...formDataError,
                stateError: formData.state ? "" : "Select State",
              }));
            }}
            errorMessage={formDataError.stateError}
          />

          {/* <InputText
            inputType="text"
            title="City"
            name="city"
            controlFunc={handleInputChange}
            controlFuncBlur={handleBlur}
            content={formData?.city || ""}
            placeholder="Enter City Name"
            disabled={false}
            maxLength={50}
            // tabIndex="9"
            isRequired={true}
            classStar="text-red-500"
            errorMessage={formDataError.cityError}
          /> */}
          <AutoDropDown
            title="City"
            placeholder="Select"
            options={data1[6] ?? []}
            name="city"
            Class="custom-class"
            // tabIndex="1"
            disabled={true}
            selectedOption={data1[6]?.find((x) => x.value == formData?.city)}
            classStar="text-red-500"
            controlFunc={(value) =>
              setFormData({
                ...formData,
                city: value.value,
              })
            }
            controlFuncBlur={() => {
              setFormDataError(() => ({
                ...formDataError,
                cityError: formData.city ? "" : "Select State",
              }));
            }}
            errorMessage={formDataError.cityError}
          />

          <InputText
            inputType="text"
            title="Door No & Street Name"
            name="streetDoorNo"
            controlFunc={handleInputChange}
            controlFuncBlur={handleBlur}
            content={formData?.streetDoorNo || ""}
            placeholder="Enter Door No & Street Name"
            disabled={true}
            maxLength={100}
            // tabIndex="9"
            isRequired={true}
            classStar="text-red-500"
            errorMessage={formDataError.streetDoorNoError}
          />

          <InputText
            inputType="text"
            title="Area"
            name="area"
            controlFunc={handleInputChange}
            controlFuncBlur={handleBlur}
            content={formData?.area || ""}
            placeholder="Enter Area Name"
            disabled={true}
            maxLength={50}
            // tabIndex="9"
            isRequired={true}
            classStar="text-red-500"
            errorMessage={formDataError.areaError}
          />

          <InputText
            inputType="text"
            title="Pin Code"
            name="pincode"
            controlFunc={handleInputChange}
            controlFuncBlur={handleBlur}
            content={formData?.pincode || ""}
            placeholder="Enter Pin Code"
            disabled={true}
            maxLength={10}
            // tabIndex="9"
            isRequired={true}
            classStar="text-red-500"
            errorMessage={formDataError.pincodeError}
          />

          <div className="text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500">
            <DropDown
              name="sourceType"
              title="Source Type"
              type={"select-one"}
              options={data1[2]}
              disabled={true}
              selectedOption={formData?.sourceType}
              controlFunc={handleInputChange}
              // controlFuncBlur={handleBlur}
              controlFuncBlur={() => {
                setFormDataError(() => ({
                  ...formDataError,
                  sourceTypeError: formData.sourceType
                    ? ""
                    : "Select Source Type",
                }));
              }}
              placeholder="Select Source Type"
              // tabIndex="12"
              errorMessage={formDataError.sourceTypeError}
            />
          </div>

          <InputText
            inputType="text"
            title="Source"
            name="source"
            controlFunc={handleInputChange}
            controlFuncBlur={handleBlur}
            content={formData?.source || ""}
            placeholder="Enter Source"
            disabled={true}
            maxLength={50}
            // tabIndex="9"
            isRequired={true}
            errorMessage={formDataError.sourceError}
          />

          <InputText
            inputType="text"
            title="Contact Number"
            name="contactNumber"
            controlFunc={handleInputChange}
            controlFuncBlur={handleBlur}
            content={formData?.contactNumber || ""}
            placeholder="Enter Contact Number"
            disabled={true}
            maxLength={15}
            // tabIndex="9"
            isRequired={true}
            errorMessage={formDataError.contactNumberError}
          />

          <div className="text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500">
            <DropDown
              name="idType"
              title="ID-Proof"
              type={"select-one"}
              options={data1[3]}
              selectedOption={formData?.idType}
              controlFunc={handleInputChange}
              disabled={true}
              // controlFuncBlur={handleBlur}
              controlFuncBlur={() => {
                setFormDataError(() => ({
                  ...formDataError,
                  idTypeError: formData.idType ? "" : "Select ID Type",
                }));
              }}
              placeholder="Select ID Type"
              // tabIndex="12"
              errorMessage={formDataError.idTypeError}
            />
          </div>

          <InputText
            inputType="text"
            title="ID-Number"
            name="idValue"
            controlFunc={handleInputChange}
            controlFuncBlur={handleBlur}
            content={formData?.idValue || ""}
            placeholder="Enter ID-Number"
            disabled={true}
            maxLength={20}
            // tabIndex="9"
            isRequired={true}
            errorMessage={formDataError.idValueError}
          />
   <InputText
            inputType="text"
            title="E-mail"
            name="email"
            controlFunc={handleInputChange}
            controlFuncBlur={handleBlur}
            content={formData?.email || ""}
            placeholder="Enter E-mail"
            disabled={true}
            maxLength={20}
            // tabIndex="9"
            isRequired={true}
            errorMessage={formDataError.emailError}
          />

          

        </div>
        <table className="min-w-full table-auto border border-gray-300 ">
          <thead className="bg-[#3D6643] text-white text-left">
            <tr>
              <th className="border px-2 py-2 w-[30px]">SN</th>
              <th className="border px-4 py-2 w-[270px]">Room Type</th>
              <th className="border px-4 py-2 w-[30px]">Available Rooms</th>
              <th className="border px-4 py-2 w-[160px]">Basic Tariff</th>
              <th className="border px-4 py-2 w-[160px]">Spl. Tariff</th>
              <th className="border px-4 py-2 w-[100px]">No. Of rooms</th>
              <th className="border px-2 py-2 w-[80px]">No. Of Adults</th>
              <th className="border px-2 py-2 w-[80px]">No. Of Children</th>
              <th className="border px-2 py-2 w-[150px]">Amount</th>
              {/* <th className="border px-4 py-2 w-[80px]">Action</th> */}
            </tr>
          </thead>
          <tbody>
            {tableData.map((room, index) => (
              <tr key={index}>
                <td className="border px-2 py-2">{index + 1}</td>

                <td className="border px-4 py-2">
                  <DropDown
                    name="Rooms Type"
                    options={[{ value: room.RoomTypeId, label: room.RoomType }]}
                    selectedOption={room.RoomTypeId}
                    disabled={true}
                  />
                </td>
                <td className="border px-4 py-2">
                  <InputText
                    name="availablerooms"
                    disabled={true}
                    content={room.AvailableRooms}
                    controlFunc={(e) =>
                      handletableDataChange(e.target, index, "AvailableRooms")
                    }
                  />
                </td>
                <td className="border px-4 py-2">
                  <InputText
                    name="Tariff"
                    content={room.Tariff}
                    disabled={true}
                    controlFunc={(e) =>
                      handletableDataChange(e.target, index, "Tariff")
                    }
                  />
                </td>
                <td className="border px-4 py-2">
                  <InputText
                    name="specialtariff"
                    content={room.specialtariff}
                    disabled={true}
                    controlFunc={(e) =>
                      handletableDataChange(e.target, index, "specialtariff")
                    }
                  />
                </td>
                <td className="border px-4 py-2">
                  <InputText
                    name="numberofrooms"
                    content={room.Numberofrooms}
                    disabled={true}
                    controlFunc={(e) =>
                      handletableDataChange(e.target, index, "Numberofrooms")
                    }
                  />
                </td>
                <td className="border px-2 py-2">
                  <InputText
                    name="numberofadults"
                    content={room.numberofadults}
                    disabled={true}
                    controlFunc={(e) =>
                      handletableDataChange(e.target, index, "numberofadults")
                    }
                  />
                </td>
                <td className="border px-2 py-2">
                  <InputText
                    name="numberofchildren"
                    content={room.numberofchildren}
                    disabled={true}
                    controlFunc={(e) =>
                      handletableDataChange(e.target, index, "numberofchildren")
                    }
                  />
                </td>
                <td className="border px-2 py-4">
                  <InputText
                    name="amount"
                    content={tableData[index].amount}
                    disabled={true}
                    controlFunc={(e) =>
                      handletableDataChange(e.target, index, "amount")
                    }
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className={mainTable.grid3}>
          <div></div>
          <div></div>
          <div className="flex justify-end">
            <InputText
              title="Total"
              classDiv="flex gap-2 items-center justify-end mt-2 w-[140px]"
              name="quantity"
              content={formData?.bookingTotalAmount}
              controlFunc={handleInputChange}
              disabled={true}
            />
          </div>
        </div>
        <div></div>

        <div className="mx-auto p-4 max-w-7xl">
          <ul className="space-y-4">
            {tableData?.map((room, index) => (
              <li
                key={index}
                className="border border-green-500 rounded-md p-4 shadow-sm bg-white"
              >
                <div className="flex flex-col  items-start  justify-between ">
                  <h2 className="text-lg font-semibold text-gray-800 mb-2">
                    {room.RoomType}
                  </h2>
                  <div className="flex flex-col md:flex-row items-start md:gap-x-10">
                    <img
                      src={room.Photo}
                      alt="Room"
                      className="h-48 w-36 object-cover rounded-md border"
                    />
                    <div>
                      <div className="flex-1 flex-col w-full">
                        <div className="flex flex-col md:flex-row md:gap-x-12 flex-1">
                          <div className="flex-2 space-y-1">
                            <p className="text-sm text-gray-600  font-semibold">
                              Room Details
                            </p>
                            <p className="text-sm text-gray-600">
                              Property Size:{room.Size}
                            </p>
                            <p className="text-sm text-gray-600">
                              Maximum Occupancy: {room.MaxOccupancy}
                            </p>
                            <p className="text-sm text-gray-600">
                              Villa Type: {room.RoomType}
                            </p>
                          </div>

                          <div className="flex-2 space-y-1">
                            <p className="text-sm text-gray-600 font-semibold ">
                              Space Details
                            </p>
                            {room.SpaceDetails ? (
                              <ul className="text-sm text-gray-600">
                                {room.SpaceDetails.split(",").map(
                                  (item, idx) => (
                                    <li key={idx}>
                                      {idx + 1}. {item.trim()}
                                    </li>
                                  )
                                )}
                              </ul>
                            ) : (
                              <p className="text-sm text-gray-600">
                                Space Details: Not Available
                              </p>
                            )}
                          </div>

                          <div className="flex-2 space-y-1">
                            <p className="text-sm text-gray-600 font-semibold">
                              AmenitiesDetails
                            </p>
                            {room.AmenitiesDetails ? (
                              <ul className="text-sm text-gray-600 ">
                                {room.AmenitiesDetails.split(",").map(
                                  (item, idx) => (
                                    <li key={idx}>
                                      {idx + 1}. {item.trim()}
                                    </li>
                                  )
                                )}
                              </ul>
                            ) : (
                              <p className="text-sm text-gray-600 ">
                                Amenities Details: Not Available
                              </p>
                            )}
                          </div>
                        </div>

                        <div className="flex flex-row justify-between gap-8 mt-4">
                          <div className="flex flex-col gap-2">
                            <p className="text-sm font-semibold text-gray-700">
                              Rooms: {room.NoOfRequiredRooms}
                            </p>
                            <div className="flex gap-2 flex-wrap">

                              {room.AvailableRoomsId && room.AvailableRoomsId.trim() !== "" ? (
                                room.AvailableRoomsId
                                  .split(",")
                                  .map((roomIdStr) => {
                                    const roomId = Number(roomIdStr.trim());
                                    // Check if this roomId is in the selected rooms
                                    const isSelectedRoom = room.selectedRooms
                                      ? room.selectedRooms.split(",").some(selectedId => Number(selectedId.trim()) === roomId)
                                      : false;

                                    // Get the room name if available
                                    const roomName = room.AvailableRoomsName
                                      ? room.AvailableRoomsName.split(",").find((name, idx) => {
                                        const ids = room.AvailableRoomsId.split(",");
                                        return idx < ids.length && Number(ids[idx].trim()) === roomId;
                                      })
                                      : `Room ${roomId}`;

                                    return (
                                      <span
                                        key={roomId}
                                        className={`inline-block px-3 py-2 h-8 text-sm font-medium rounded-md text-white transition opacity-50 cursor-not-allowed ${isSelectedRoom ? "bg-red-500" : "bg-green-500"
                                          }`}
                                      >
                                        {roomName ? roomName.trim() : `Room ${roomId}`}
                                      </span>
                                    );
                                  })
                              ) : (
                                <span className="text-sm text-gray-500">No rooms available</span>
                              )}
                              {/* {(room.AvailableRoomsId || "")
                                .split(",")
                                .map((roomIdStr) => {
                                  const roomId = Number(roomIdStr.trim());
                                  const isChecked =
                                    selectedRooms[index]?.includes(roomId);

                                  return (
                                    <label
                                      key={roomId}
                                      className="cursor-pointer"
                                    >
                                      <input
                                        type="checkbox"
                                        className="hidden peer"
                                        checked={isChecked}
                                        disabled={true}
                                        // onChange={() =>
                                        //   handleToggleRoom(index, roomId)
                                        // }
                                      />
                                      <span
                                        // className={`inline-block px-3 py-2 h-8 text-sm font-medium rounded-md text-white transition ${
                                        //   isChecked
                                        //     ? "bg-red-800"
                                        //     : "bg-green-500 hover:bg-green-600"
                                        // }`}
                                        className="inline-block px-3 py-2 h-8 text-sm font-medium rounded-md text-white bg-green-500 transition opacity-50 cursor-not-allowed"
                                      >
                                        {roomId}
                                      </span>
                                    </label>
                                  );
                                })} */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>



        <div className={mainTable.grid3}>

        <DropDown
  name="lostReason"
  title="Reason for Cancellation"
  type="select-one"
  options={lostreasondropdown}
  selectedOption={formData.lostReason === 0 ? "" : formData.lostReason}
  controlFunc={(e) => {
    setFormData({
      ...formData,
      lostReason: Number(e.target.value),
    });
  }}
  placeholder="Select Reason"
  disabled={viewPopUp}
  errorMessage={formDataError.lostReasonError}
/>


          <InputText
            Class={mainTable.inputAmount}
            inputType="text"
            title="Total Amount"
            name="bookingTotalAmount"
            controlFunc={handleInputChange}
            controlFuncBlur={handleBlur}
            content={formData?.bookingTotalAmount}
            placeholder="0.00"
            errorMessage={formDataError.bookingTotalAmountError}
            disabled={true}
            isRequired={true}
            // tabIndex="11"
            classStar="text-red-500"
          />

          <InputText
            Class={mainTable.inputAmount}
            inputType="text"
            title="Received Amount "
            name="bookingReceivedAmount"
            content={formData?.bookingReceivedAmount}
            // controlFunc={(e) => {
            //   const value = parseFloat(e.target.value) || 0;

            //   if (value <= formData.bookingTotalAmount) {
            //     setFormData({
            //       ...formData,
            //       bookingReceivedAmount: value,
            //       bookingBalanceAmount: formData.bookingTotalAmount - value,
            //     });
            //   }
            // }}
            // controlFuncBlur={handleBlur}
            placeholder="0.00"
            // errorMessage={formDataError.bookingReceivedAmountError}
            disabled={true}
            maxLength={8}
            isRequired={true}
            // tabIndex="11"
            classStar="text-red-500"
          />
          {viewPopUp && (
            <InputText
              Class={mainTable.inputAmount}
              inputType="text"
              title="Balance Amount "
              name="bookingBalanceAmount"
              content={formData?.bookingBalanceAmount}
              // controlFunc={(e) => {
              //   const value = parseFloat(e.target.value) || 0;

              //   if (value <= formData.bookingTotalAmount) {
              //     setFormData({
              //       ...formData,
              //       bookingReceivedAmount: value,
              //       bookingBalanceAmount: formData.bookingTotalAmount - value,
              //     });
              //   }
              // }}
              // controlFuncBlur={handleBlur}
              placeholder="0.00"
              // errorMessage={formDataError.bookingReceivedAmountError}
              disabled={true}
              maxLength={8}
              isRequired={true}
              // tabIndex="11"
              classStar="text-red-500"
            />
          )}

          <InputText
            Class={mainTable.inputAmount}
            inputType="text"
            title="Refund Amount"
            name="refundAmount"
            content={formData?.refundAmount}
            controlFunc={(e) => {
              const value = parseFloat(e.target.value) || 0;

              if (value <= formData.bookingReceivedAmount) {
                setFormData({
                  ...formData,
                  refundAmount: value,
                  revenue: formData.bookingReceivedAmount - value,
                });
              }
            }}
            controlFuncBlur={handleBlur}
            placeholder="0.00"
            errorMessage={formDataError.bookingReceivedAmountError}
            disabled={viewPopUp ? true : false}
            maxLength={8}
            isRequired={true}
            // tabIndex="11"
          // classStar="text-red-500"
          />

          {!viewPopUp && (
            <InputText
              Class={mainTable.inputAmount}
              inputType="text"
              title="Revenue"
              name="revenue"
              content={formData?.revenue}
              controlFunc={handleInputChange}
              controlFuncBlur={handleBlur}
              placeholder="0.00"
              disabled={true}
              isRequired={true}
              // tabIndex="11"
              classStar="text-red-500"
            />
          )}
          <DropDown
            name="bookingPaymentType"
            title="Payment Type"
            type={"select-one"}
            options={data1[5]}
            selectedOption={formData?.bookingPaymentType}
            controlFunc={handleInputChange}
            controlFuncBlur={handleBlur}
            placeholder="Select Payment Type"
            // tabIndex="12"
            disabled={viewPopUp ? true : false}
            errorMessage={formDataError.bookingPaymentTypeError}
          // classStar="text-red-500"
          />

          <InputText
            inputType="text"
            title="Payment Reference Number"
            name="bookingPaymentReferenceNumber"
            controlFunc={handleInputChange}
            controlFuncBlur={handleBlur}
            content={formData?.bookingPaymentReferenceNumber}
            placeholder=""
            disabled={viewPopUp ? true : false}
            isRequired={true}
            maxLength={20}
            // tabIndex="11"
            errorMessage={formDataError.bookingPaymentReferenceNumberError}
          // classStar="text-red-500"
          />
        </div>
        {!viewPopUp && (
          <FileUpload
            title="File Upload"
            // classStar="text-red-500"
            apiCall="Enquiry/CancelReferenceFileUpload"
            modalName="File"
            showImage={formData.showImage}
            showImageData={handleShowImage}
            // disabledBtn={updateScreenTitle}
            imageUploadedError={formDataError.showImageError}
            limitMassage={
              "Image size limit: 2MB. Accepted Image types:jpg, png, jpeg."
            }
            disabled={viewPopUp ? true : false}
            MAX_FILE_SIZE_MB={2}
            ALLOWED_FORMATS={["image/jpeg", "image/jpg", "image/png"]}
          />
        )}
        {viewPopUp && formData.showImage && typeof formData.showImage === "string" && formData.showImage.trim() !== "" &&
          <img
            src={formData.showImage}
            alt="Image"
            className="rounded-none w-20 h-20"
          />
        }
      </div>
      {!viewPopUp && (
        <Buttons
          addScreenTitle={true}
          // updateScreenTitle={updateScreenTitle}
          handleSubmit={handleSubmit}
          cancel={cancel}
        // disabledBtn={submitBtnDisabled ? true : false}
        />
      )}
    </>
  );
};

export default Cancelpopup;
